import { Box, Typography } from "@mui/material";
import { useEffect, useRef } from "react";

export interface SettingRowProps {
  label: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  id?: string; // 검색에서 scrollIntoView용
  highlighted?: boolean;
}

export default function SettingRow({ label, description, children, id, highlighted }: SettingRowProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (highlighted && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [highlighted]);

  return (
    <Box
      ref={ref}
      id={id}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.5,
        gap: 2,
        borderBottom: "0.5px solid",
        borderColor: "grey.200",
        "&:last-child": { borderBottom: "none" },
        bgcolor: highlighted ? "warning.50" : "transparent",
        transition: "background-color 0.4s ease",
      }}
    >
      <Box>
        <Typography fontSize={13} fontWeight={500}>
          {label}
        </Typography>
        {description && (
          <Typography fontSize={11} color="text.secondary" mt={0.25}>
            {description}
          </Typography>
        )}
      </Box>
      <Box sx={{ flexShrink: 0 }}>{children}</Box>
    </Box>
  );
}
